import React, {useEffect, useRef, useState} from 'react';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {Divider} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {useDispatch, useSelector} from "react-redux";
import {setCommonInputs} from "../../redux/reducers/common";
import {setSettingsModal} from "../../redux/reducers/dashboard";
import {Account, Logout, Settings} from "./Menu";
import {useLogout, useValidateLogin} from "../../hooks/auth";
import {useImage} from "../../hooks/misc";
import {getAvatarString} from "../../actions/commonActions";
import {PermissionProvider} from "../../hoc/withPermissions";
import {SIEMBA_CUSTOMER, SIEMBA_CUSTOMER_ENGINEER} from "../../utils/roles";
import {hasAvailableSettingsEntry} from "../../utils/constants/settingsRegistry";

const AccountDropDown = () => {
    const [anchorEl, setAnchorEl] = useState(null)
    const logout = useLogout()
    const dropdownEl = useRef(null);
    const open = Boolean(anchorEl)
    const dispatch = useDispatch()

    // ROAR-4941 (§4 decision 4): read once per render from the registry, never a hard-coded list.
    const settingsAvailable = hasAvailableSettingsEntry()

    /**
     * Dismiss the avatar menu, then hand the dialog off to Redux.
     * This component does NOT render the modal: `components/Admin/Layout` mounts it behind
     * `{settingsModal?.open && ...}`, the same way InviteCustomerModal is opened from
     * `Header/Menu.js`. Keeping the open state out of here means the dropdown unmounting can
     * never take the dialog down with it.
     */
    const openSettings = () => {
        setAnchorEl(null)
        dispatch(setSettingsModal({open: true}))
    }
    const { isMenuExpanded } = useSelector((state) => state.common);
    const {data} = useValidateLogin()
    const profile_picture = useImage(data?.user?.profile_picture, 'profile', true )
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!isMenuExpanded) {
            setAnchorEl(null);
        }
    }, [isMenuExpanded]);

    useEffect(() => {
        dispatch(setCommonInputs({
            isMenuExpanded: open
        }))
    }, [open])
    return (
        <div>
            <div className={"cursor-pointer pr-2"} onClick={handleClick}>
                {
                    data?.user?.profile_picture ?
                        <img src={profile_picture} height={33} width={33}
                             className={"rounded-full w-[33px] h-[33px] inline-block mr-3.5"} alt=""/>
                        :
                        <div
                            className={"rounded-full w-[33px] bg-primary-800 h-[33px] inline-block mr-3.5 text-center"}>
                            <span
                                className={"font-semibold text-white text-[16px] align-sub"}>{getAvatarString(`${
                                data?.user?.first_name} ${data?.user?.last_name}`)}</span>
                        </div>
                }
                {/* {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon ref={dropdownEl}/>} */}
            </div>
            <Menu
                open={open}
                anchorEl={anchorEl}
                id={"account-menu"}
                onClose={handleClose}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                variant={"menu"}
                autoFocus={false}
                className={"hidden md:block"}
            >
                <MenuItem className={"!block"}>
                    <Account/>
                </MenuItem>
                <Divider variant={"middle"}/>
                {/*
                  ROAR-4941: gated twice, on purpose.
                  - `hasAvailableSettingsEntry` (§4 decision 4) keeps this inert until ROAR-4945
                    flips a registry entry — so PRs 2-5 change nothing a user can see.
                  - `PermissionProvider roles={[...customer]}` (§4 decision 6) is the security
                    gate: AccountDropDown itself sits inside a ROLE-LESS PermissionProvider
                    (Header/index.js:275-277), so without this a siemba_admin would open Settings
                    and be served their own (nonexistent) company's billing data — the panes strip
                    the company-scope headers and let the backend resolve scope from the JWT.
                */}
                {settingsAvailable && (
                    <PermissionProvider roles={[SIEMBA_CUSTOMER, SIEMBA_CUSTOMER_ENGINEER]}>
                        <MenuItem onClick={openSettings}>
                            <Settings/>
                        </MenuItem>
                        <Divider variant={"middle"}/>
                    </PermissionProvider>
                )}
                <MenuItem onClick={() => logout.mutate()}>
                    <Logout/>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default AccountDropDown;
